import { WaterTransferAsset } from '@app/water/interfaces/water-transfer-asset.interface';
import { WaterSupplier } from '@ui/water/interfaces/water-supplier';
import { WaterTransferDocumentServiceDto } from '../types/water-transfer-document-service-dto';
import { WaterTransferAssetType } from '@ui/water/enums/water-transfer-asset-type.enum';
import { WaterTransferDocumentServiceStatus } from '@app/services/water-transfer-document/enums/water-transfer-document-service-status.enum';

export class WaterTransferDocumentService {
    transactionId: string;
    status: WaterTransferDocumentServiceStatus;
    active: boolean;
    leaverFinalInvoiceByPost: boolean;
    name: string;
    description: string;
    supplier?: WaterSupplier;
    waterTransferAssets?: WaterTransferAsset[];
    states?: {
        meterComplete: boolean;
        newResidentsInfo: boolean;
    };
    transferDocumentComplete?: boolean;
    serviceTypeId: string;

    constructor(partial: WaterTransferDocumentServiceDto) {
        this.transactionId = partial.transactionId;
        this.status = partial.status;
        this.active = partial.active;
        this.leaverFinalInvoiceByPost = partial.leaverFinalInvoiceByPost;
        this.name = partial.name;
        this.description = partial.description;
        this.supplier = partial.supplier;
        this.waterTransferAssets = partial.waterTransferAssets;
        this.states = partial.states;
        this.transferDocumentComplete = partial.transferDocumentComplete;
        this.serviceTypeId = partial.serviceTypeId;
    }

    public isActive(): boolean {
        return !!this.active;
    }

    public isNotActive(): boolean {
        return !this.active;
    }

    /**
     * Retrieves the water transfer document from the list of water transfer assets.
     * The method searches for an asset with the water transfer asset type set to "TransferDocument".
     *
     * @return {WaterTransferAsset} The water transfer document if found; otherwise, undefined.
     */
    public getWaterTransferDocument(): WaterTransferAsset {
        return this.waterTransferAssets?.find((asset) => asset.waterTransferAssetType === WaterTransferAssetType.TransferDocument);
    }

    public hasWaterTransferDocument(): boolean {
        if (!this.waterTransferAssets || this.waterTransferAssets.length === 0) {
            return false;
        }

        return this.waterTransferAssets.some((asset) => asset.waterTransferAssetType === WaterTransferAssetType.TransferDocument);
    }

    public newResidentsInfoComplete(): boolean {
        return !!this.states?.newResidentsInfo;
    }

    public meterComplete(): boolean {
        return !!this.states?.meterComplete;
    }

    public supplierComplete(): boolean {
        return !!this.supplier;
    }

    public isComplete(): boolean {
        return this.status === WaterTransferDocumentServiceStatus.Complete;
    }

    public isNotComplete(): boolean {
        return this.status === WaterTransferDocumentServiceStatus.NotComplete;
    }
}
